module.exports = __webpack_public_path__ + "img/question-set-point.45169666.png";